import { gql } from "gql";

export const GET_COMPLETED_TIPS = gql(/* GraphQL */ `
  query GetCompletedTips {
    getCompletedTips {
      tipKey
      value
    }
  }
`);
